import { render, staticRenderFns } from "./ProfileAttentionCreated.vue?vue&type=template&id=19e7589a&scoped=true&"
import script from "./ProfileAttentionCreated.vue?vue&type=script&lang=js&"
export * from "./ProfileAttentionCreated.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAttentionCreated.vue?vue&type=style&index=0&id=19e7589a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e7589a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('19e7589a', component.options)
    } else {
      api.reload('19e7589a', component.options)
    }
    module.hot.accept("./ProfileAttentionCreated.vue?vue&type=template&id=19e7589a&scoped=true&", function () {
      api.rerender('19e7589a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/student-profile/components/attention_created/ProfileAttentionCreated.vue"
export default component.exports